class BoomProductBundle extends HTMLElement {
  static GLOBAL_STATE_KEY = '__BOOM_BUNDLE_STATE__';

  constructor() {
    super();
    this.bundleMultiple = this.getAttribute('data-multiple') === 'true';
    this.hasBundle = false;
    this.bundleVariantId = null;
    this.productPrice = 0;
    this.productComparePrice = 0;
    this._selectedVariantIds = []; 
    this._moCards = null;
    this._moVariant = null;
    this._variantInputEl = null;
  }

  _getStateKey() {
    return this.getAttribute('data-shopify-id') || this.id || document.location.pathname;
  }
  _loadGlobalState() {
    const key = this._getStateKey();
    return (window[BoomProductBundle.GLOBAL_STATE_KEY] || {})[key] || [];
  }
  _saveGlobalState() {
    const key = this._getStateKey();
    if (!window[BoomProductBundle.GLOBAL_STATE_KEY]) {
      window[BoomProductBundle.GLOBAL_STATE_KEY] = {};
    }
    window[BoomProductBundle.GLOBAL_STATE_KEY][key] = this._selectedVariantIds.slice();
  }

  connectedCallback() {
    this._selectedVariantIds = this._loadGlobalState();

    this.bundleTotalPriceEl = this.querySelector('.bundle_product_total_price');
    this.nowBundlePriceEl = this.querySelector('.bundle_product_original_price');
    this.comparePriceEl = this.querySelector('.bundle_product_compare_price');
    this.productPrice = Number(this.nowBundlePriceEl?.getAttribute('data-price')) || 0;
    this.productComparePrice = Number(this.nowBundlePriceEl?.getAttribute('data-compare-price')) || this.productPrice;

    this._bindCardClick();
    this._restoreSelection();
    this._listenCardReMount();

    this._patchAddToCart();
    this._patchAcceleratedCheckout();
    this._listenVariantChange();
  }

  disconnectedCallback() {
    if (this._moCards) {
      this._moCards.disconnect();
      this._moCards = null;
    }
    if (this._moVariant) {
      this._moVariant.disconnect();
      this._moVariant = null;
    }
    if (this._variantInputEl) {
      this._variantInputEl.removeEventListener?.('change', this._onVariantBound);
      this._variantInputEl = null;
    }
  }

  _bindCardClick() {
    this.querySelectorAll('.card').forEach((card) => {
      card.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleBundle(card);
      });
    });
  }
  _restoreSelection() {
    if (!this._selectedVariantIds.length) {
      this.hasBundle = false;
      this.bundleVariantId = null;
      if (this.bundleTotalPriceEl) this.bundleTotalPriceEl.style.display = 'none';
      return;
    }
    let matched = 0;
    this.querySelectorAll('.card').forEach((card) => {
      const id = card.getAttribute('data-variant-id');
      if (id && this._selectedVariantIds.includes(id)) {
        card.classList.add('selected');
        const cb = card.querySelector('input[type="checkbox"]');
        if (cb) cb.checked = true;
        matched++;
      } else {
        card.classList.remove('selected');
        const cb = card?.querySelector?.('input[type="checkbox"]');
        if (cb) cb.checked = false;
      }
    });
    this.hasBundle = matched > 0;
    if (this.bundleTotalPriceEl) {
      this.bundleTotalPriceEl.style.display = this.hasBundle ? 'flex' : 'none';
    }
    this.bundleVariantId = this.bundleMultiple
      ? this._selectedVariantIds.slice()
      : (this._selectedVariantIds[0] || null);

    if (matched > 0) {
      const selectedCards = this.querySelectorAll('.card.selected');
      this.updateTotalPrice(selectedCards);
    }
  }

  _listenCardReMount() {
    const container = this.querySelector('#another-bundle');
    if (!container) return;
    if (this._moCards) this._moCards.disconnect();

    let rafPending = null;
    const handleMutations = () => {
      if (rafPending) return;
      rafPending = requestAnimationFrame(() => {
        rafPending = null;
        this._moCards?.disconnect();
        this._bindCardClick();
        this._restoreSelection();
        this._listenCardReMount(); // 重新挂载 observer
      });
    };

    this._moCards = new MutationObserver(handleMutations);
    this._moCards.observe(container, { childList: true, subtree: true });
  }

  _listenVariantChange() {
    if (this._moVariant) {
      this._moVariant.disconnect();
      this._moVariant = null;
    }
    if (this._variantInputEl) {
      this._variantInputEl.removeEventListener('change', this._onVariantBound);
      this._variantInputEl = null;
    }

    const tryListen = (retries = 0) => {
      const section = this._findSection();
      if (!section) {
        if (retries < 30) setTimeout(() => tryListen(retries + 1), 300);
        return;
      }
      const form = section.querySelector('form[action*="/cart/add"]');
      const variantInput = form?.querySelector('input[name="id"]');
      if (!variantInput) {
        if (retries < 30) setTimeout(() => tryListen(retries + 1), 300);
        return;
      }
      this._variantInputEl = variantInput;
      const self = this;
      let lastValue = variantInput.value;

      const onVariantChanged = async () => {
        if (variantInput.value === lastValue) return;
        lastValue = variantInput.value;
        const newVariantId = Number(variantInput.value);
        if (!newVariantId) return;

        const variant = await self._fetchVariantPrice(newVariantId);
        if (!variant) return;

        self.productPrice = variant.price;
        self.productComparePrice = variant.compare_at_price || variant.price;

        // 更新 DOM data 属性（原价那一行）
        if (self.nowBundlePriceEl) {
          self.nowBundlePriceEl.setAttribute('data-price', variant.price);
          self.nowBundlePriceEl.setAttribute('data-compare-price', self.productComparePrice);
          self.nowBundlePriceEl.textContent = self.formatMoney(variant.price);
        }
        if (self.comparePriceEl) {
          if (self.productComparePrice > variant.price) {
            self.comparePriceEl.textContent = self.formatMoney(self.productComparePrice);
            self.comparePriceEl.hidden = false;
          } else {
            self.comparePriceEl.hidden = true;
          }
        }

        const selected = self.querySelectorAll('.card.selected');
        if (selected.length) {
          self.updateTotalPrice(selected);
        }
      };
      this._onVariantBound = onVariantChanged;
      this._moVariant = new MutationObserver(() => onVariantChanged());
      this._moVariant.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      variantInput.addEventListener('change', onVariantChanged);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => tryListen(), { once: true });
    } else {
      tryListen();
    }
  }

  async _fetchVariantPrice(variantId) {
    const section = this._findSection();
    const productEl = section?.querySelector?.('[xo-product-information], [xo-featured-product]')
      || section?.closest?.('[xo-product-information], [xo-featured-product]');
    let handle = productEl?.getAttribute?.('xo-product-handle');
    if (!handle) {
      const m = window.location.pathname.match(/\/products\/([^/?#]+)/);
      if (m) handle = m[1];
    }
    if (!handle) return null;
    if (!window.__BOOM_BUNDLE_PRODUCT_CACHE__) {
      window.__BOOM_BUNDLE_PRODUCT_CACHE__ = {};
    }
    if (!window.__BOOM_BUNDLE_PRODUCT_CACHE__[handle]) {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) return null;
        window.__BOOM_BUNDLE_PRODUCT_CACHE__[handle] = await res.json();
      } catch (e) {
        console.error('[ProductBundle] fetch product failed:', e);
        return null;
      }
    }

    const json = window.__BOOM_BUNDLE_PRODUCT_CACHE__[handle];
    const v = json.variants?.find((x) => x.id === variantId);
    if (!v) return null;
    return { price: v.price, compare_at_price: v.compare_at_price };
  }

  /**
   * Find the parent product section containing add-to-cart buttons and forms.
   */
  _findSection() {
    let el = this;
    while (el) {
      if (el.hasAttribute?.('xo-product-information') ||
          el.hasAttribute?.('xo-featured-product')) {
        return el;
      }
      if (el.tagName === 'SECTION' && el.id?.startsWith('shopify-section-')) {
        return el;
      }
      el = el.parentElement;
    }
    return this.closest('.shopify-section') || this.parentElement;
  }

  _getCartSections() {
    if (window.Xotiny) {
      const cartMini = document.querySelector('xo-cart-mini');
      return cartMini?.id ? [cartMini.id] : [];
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  _getMainProductInfo(cartAddBtn, section) {
    let variantId = null;
    let quantity = 1;
    let sellingPlan = null;
    const form = cartAddBtn.closest('form[action*="/cart/add"]')
      || section.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const qtyInput = form?.querySelector('input[name="quantity"]');
    // selling_plan is a hidden input (not a checked radio) in this theme
    const sellingPlanInput = form?.querySelector('input[name="selling_plan"]');
    if (variantInput?.value) {
      variantId = Number(variantInput.value);
      quantity = Number(qtyInput?.value) || 1;
      sellingPlan = sellingPlanInput?.value ? Number(sellingPlanInput.value) : null;
    } else if (typeof cartAddBtn.getOptions === 'function') {
      // Fallback: read from the theme's own component options
      const opts = cartAddBtn.getOptions();
      const rawId = opts.xoVariantId || opts.xoProductId;
      if (rawId) {
        variantId = Number(String(rawId).replace(/^\[|\]$/g, ''));
        quantity = Number(opts.xoProductQuantity) || 1;
      }
    }

    return { variantId, quantity, sellingPlan };
  }
  _patchAddToCart() {
    const tryPatch = (retries = 0) => {
      const section = this._findSection();
      if (!section) {
        if (retries < 30) setTimeout(() => tryPatch(retries + 1), 300);
        return;
      }
      if (section.__bundleCartClickInstalled) return;
      section.__bundleCartClickInstalled = true;

      const self = this;

      const captureHandler = async function (event) {
        if (!self.hasBundle) return;
        const cartAddBtn = event.target.closest('xo-cart-add, xo-bundle-add');
        if (!cartAddBtn) return;
        if (cartAddBtn.hasAttribute('xo-disabled')) return;
        event.stopImmediatePropagation();
        event.preventDefault();
        const items = [];

        const main = self._getMainProductInfo(cartAddBtn, section);
        if (main.variantId) {
          const item = { id: main.variantId, quantity: main.quantity };
          if (main.sellingPlan) item.selling_plan = main.sellingPlan;
          items.push(item);
        }

        const bundleIds = Array.isArray(self.bundleVariantId)
          ? self.bundleVariantId
          : [self.bundleVariantId].filter(Boolean);
        bundleIds.forEach((id) => {
          const numId = Number(id);
          if (numId) items.push({ id: numId, quantity: 1 });
        });
        if (!items.length) return;
        cartAddBtn.setAttribute('xo-loading', '');
        try {
          const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items,
              sections: self._getCartSections(),
              section_url: window.location.pathname
            })
          });

          if (!res.ok) {
            const errData = await res.json().catch(() => ({}));
            console.error('[ProductBundle] Combined add to cart failed:', res.status, errData);
            return;
          }

          const data = await res.json();

          if (window.xoStore && typeof window.xoStore.set === 'function') {
            window.xoStore.set('xo-cart', (prev) => ({
              ...prev,
              size: data.items
                ? data.items.reduce((acc, i) => acc + i.quantity, prev.size)
                : prev.size + items.length,
              sections: data.sections || prev.sections,
              items: data.items || prev.items,
              addIdLoading: '',
              isAdded: true,
              variantId: String(main.variantId || ''),
              productIdsForCartNotification: items.map((i) => String(i.id))
            }))('xo-cart/bundleAddSuccess');
          }

          // Open the cart drawer
          setTimeout(() => {
            if (window.xoModal && typeof window.xoModal.open === 'function') {
              window.xoModal.open('cart');
            } else {
              const cartTrigger = document.querySelector('[xo-name="cart"][role="button"]');
              if (cartTrigger) cartTrigger.click();
            }
          }, 400);
        } catch (e) {
          console.error('[ProductBundle] Combined add network error:', e);
        } finally {
          cartAddBtn.removeAttribute('xo-loading');
        }
      };

      // Capture phase: runs BEFORE the theme's bubble-phase click listener on <button>
      section.addEventListener('click', captureHandler, true);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => tryPatch(), { once: true });
    } else {
      tryPatch();
    }
  }

  _patchAcceleratedCheckout() {
    const tryPatch = (retries = 0) => {
      const section = this._findSection();
      if (!section) {
        if (retries < 30) setTimeout(() => tryPatch(retries + 1), 300);
        return;
      }

      if (section.__bundleSubmitInstalled) return;
      section.__bundleSubmitInstalled = true;

      const self = this;
      let reentrancyGuard = false;

      section.addEventListener('submit', async function (event) {
        if (reentrancyGuard) return;
        if (!self.hasBundle) return;
        const form = event.target.closest('form');
        if (!form) return;
        if (!form.action.includes('/cart/add') && form.getAttribute('data-type') !== 'add-to-cart-form') return;

        const variantIds = Array.isArray(self.bundleVariantId)
          ? self.bundleVariantId
          : [self.bundleVariantId].filter(Boolean);

        if (!variantIds.length) return;

        event.stopImmediatePropagation();
        event.preventDefault();

        try {
          const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: variantIds.map((id) => ({ id: Number(id), quantity: 1 }))
            })
          });
          if (!res.ok) {
            const errData = await res.json().catch(() => ({}));
            console.error('[ProductBundle] Bundle add for accelerated checkout failed:', res.status, errData);
          }
        } catch (e) {
          console.error('[ProductBundle] Bundle add network error:', e);
        }
        reentrancyGuard = true;
        try {
          form.submit();
        } finally {
          setTimeout(() => { reentrancyGuard = false; }, 0);
        }
      }, true);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => tryPatch(), { once: true });
    } else {
      tryPatch();
    }
  }

  toggleBundle(item) {
    const variantId = item.getAttribute('data-variant-id');

    if (item.classList.contains('selected') && !this.bundleMultiple) {
      item.classList.remove('selected');
      this.hasBundle = false;
      this.bundleVariantId = null;
      this._selectedVariantIds = [];
      if (this.bundleTotalPriceEl) this.bundleTotalPriceEl.style.display = 'none';
      this._saveGlobalState();
      return;
    }

    if (this.bundleMultiple) {
      if (item.classList.contains('selected')) {
        item.classList.remove('selected');
      } else {
        item.classList.add('selected');
      }
      this.checkHasBundle();
    } else {
      // Single-select: deselect previous, select new
      this.querySelectorAll('.card').forEach((citem) => {
        citem.classList.remove('selected');
      });
      item.classList.add('selected');
      this.bundleVariantId = variantId;
      this._selectedVariantIds = variantId ? [variantId] : [];
      this.hasBundle = true;
      if (this.bundleTotalPriceEl) this.bundleTotalPriceEl.style.display = 'flex';
      this._saveGlobalState();
      this.updateTotalPrice([item]);
    }
  }

  checkHasBundle() {
    const selectedItems = this.querySelectorAll('.card.selected');
    this.hasBundle = selectedItems.length > 0;
    if (this.bundleTotalPriceEl) {
      this.bundleTotalPriceEl.style.display = this.hasBundle ? 'flex' : 'none';
    }
    this.bundleVariantId = [];
    this._selectedVariantIds = [];
    selectedItems.forEach((item) => {
      const id = item.getAttribute('data-variant-id');
      this.bundleVariantId.push(id);
      this._selectedVariantIds.push(id);
    });
    this._saveGlobalState();
    this.updateTotalPrice(selectedItems);
  }

  updateTotalPrice(items) {
    let totalPrice = 0;
    let totalCompare = 0;
    let maxPriceOff = 0;

    items.forEach((item) => {
      totalPrice += Number(item.getAttribute('data-price')) || 0;
      totalCompare += Number(item.getAttribute('data-compare-price')) || 0;
      const po = Number(item.getAttribute('data-price-off')) || 0;
      if (po > maxPriceOff) maxPriceOff = po;
    });
    const mainPrice = maxPriceOff > 0
      ? Math.round(this.productPrice * (1 - maxPriceOff))
      : this.productPrice;
    totalPrice += mainPrice;
    totalCompare += this.productComparePrice;
    if (this.nowBundlePriceEl) {
      this.nowBundlePriceEl.textContent = this.formatMoney(totalPrice);
    }
    if (this.comparePriceEl) {
      if (totalCompare > totalPrice) {
        this.comparePriceEl.textContent = this.formatMoney(totalCompare);
        this.comparePriceEl.hidden = false;
      } else {
        this.comparePriceEl.hidden = true;
      }
    }
  }

  formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
}

if (!customElements.get('boom-product-bundle')) {
  customElements.define('boom-product-bundle',BoomProductBundle);
}
